<script>  
  import { fade } from "svelte/transition";
  import { redirect } from "../pager";
  import axios from "axios";
  import Location from "../components/Location.svelte";
  import { notif, session } from "../components/js/notif";
  let notify;
  notif.subscribe((value) => {
    notify = value;
  });
  let settings;
  session.subscribe((value) => {
    settings = value;
  });
  


  export let backbtn = false;
  export let title = "";
  export let message = "Selamat Datang";
  export let align = "left";
  export let filter = false;
  export let filtercustom = false;
  let new_scroll_position = 0;
  let last_scroll_position;
  let navToggleclass = " lg:mt-0 md:mt-0 mt-12 top-0 left-0 z-10";
  window.addEventListener("scroll", function (e) {
    last_scroll_position = window.scrollY;
    // Scrolling down
    if (
      new_scroll_position < last_scroll_position &&
      last_scroll_position > 80
    ) {
      navToggleclass = " lg:mt-0 md:mt-0 -mt-2 top-0 left-0 z-10";
    } else if (new_scroll_position > last_scroll_position) {
      navToggleclass = " lg:mt-0 md:mt-0 mt-12 top-0 left-0 z-10";
    }

    new_scroll_position = last_scroll_position;
  });
  let navToggleMobileval = "hidden";
  let navToggleMobile = {
    show: "false",
  };

  function handleNavigationToggle() {
    navToggleMobile.show = !navToggleMobile.show;
    if (!navToggleMobile.show) {
      navToggleMobileval = "block";
      document.body.style.overflowY = "hidden";
    } else {
      navToggleMobileval = "hidden";
      document.body.style.overflowY = "auto";
    }

    
  }

  function toggleFilter() {
    if (document.getElementById("filterCont").style.display == "none") {
      document.getElementById("filterCont").style.display = "block";
    } else if (document.getElementById("filterCont").style.display == "block") {
      document.getElementById("filterCont").style.display = "none";
    } else {
      document.getElementById("filterCont").style.display = "block";
    }
  }
  let flexfilter = "";
  if (filter) {
    flexfilter = "flex justify-between";
  }

  import { activeRoute } from "../pager/Router.svelte";
  let q = "";
  $: query = q.replace(/\s+/g, "+");
  function handleSearch() {
    if (query != "") {
      var url = $activeRoute.path.split("/");
      if (url[1] == "cari") {
        redirect("/belanja/q/" + query);
      } else {
        redirect("/cari/q/" + query);
      }
    }
  }

  function showhideEl(el){ 
    if(document.getElementById(el).style.display =="block"){
      document.getElementById(el).style.display = "none";
    }else{
      document.getElementById(el).style.display = "block";
    } 
  }
  
  $: listcategory = [];
  function loadCat(cat = false) {
    if (cat) {
      category = cat;
    }
    axios
      .get(settings.url + "/warga/categories", {
        params: {
          authorization: settings.token,
          category: "",
          q: "-",
          domain: "",
          market: true,
        },
      })
      .then(function (response) {
        listcategory = response.data.data; 
      });
  }
 if(settings){
  loadCat(); 
  }

  let uid= Math.random().toString(36).substring(2);
</script>

<header 
transition:fade
  class="fixed top-0 left-0 z-50 flex items-center justify-between w-full h-12 p-2 py-3 bg-white shadow-sm mobile-header md:hidden"
  style=""> 

  <nav class="flex items-center justify-between w-full h-full py-2">
    <button
    on:click={handleNavigationToggle}
      type="button"
      class="block p-2 text-center border border-gray-300 rounded-lg lg:hidden md:block color-gray-800 focus:outline-none"
      aria-label="toggle menu">
      {#if notify}
        {#if notify.jualan > 0}
      <span class="absolute top-0 w-3 h-3 mt-2 ml-3 font-mono text-xs font-normal text-center text-red-700 bg-red-500 bg-opacity-75 rounded-full">&nbsp;</span>
        {/if}
      {/if}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        class="w-4 h-4"><path
          d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" /></svg></button>
    <a
      class="block h-5 mx-auto -mt-3 text-2xl font-bold text-center text-black"
      href="./"><img src="./assets/logo/logo.svg" alt="Dekatan" class="h-8"  width="140" height="32"/></a>
      
      {#if notify}
        {#if notify.cart > 0}
        <a
        class="flex p-2 text-center border border-gray-300 rounded-lg md:hidden color-gray-800"
        href="/belanja/p/keranjang">
        <span class="absolute top-0 w-3 h-3 mt-2 -ml-3 font-mono text-xs font-normal text-center text-green-700 bg-green-500 bg-opacity-75 rounded-full">&nbsp;</span><img 
          class="w-4 h-4 m-auto" src="./assets/svg/cart.svg" alt="cart" width="20" height="20"/>
      </a>
      {:else}
    <a
      class="flex p-2 text-center border border-gray-300 rounded-lg md:hidden color-gray-800"
      href="/belanja/p/keranjang"><img 
      class="w-4 h-4 m-auto" src="./assets/svg/cart.svg" alt="cart" width="20" height="20"/>
    </a>
        {/if}
        {:else}
        <a class="flex px-2 py-1 text-xs text-center text-green-800 border-2 border-green-300 rounded-lg rounded-tr-none md:hidden" href="/belanja/p/keranjang">MASUK</a>
      {/if}
  </nav>
</header>

<div transition:fade class="bg-white fixed w-full {navToggleclass} transition-all
  ease-in-out duration-100 shadow-sm">
  <div
    class="hidden w-full h-8 px-2 py-1 bg-gray-200 border-b border-gray-200 shadow-inner mobile-header lg:block md:block">
    <div
      class="justify-between max-w-screen-xl mx-auto text-sm font-light text-gray-700 md:flex md:items-center md:justify-between">
      <div
        class="flex items-center justify-center w-full py-2 md:w-auto md:py-0">
        <svg
          class="w-5 h-5 mr-2"
          width="21"
          height="15"
          viewBox="0 0 21 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.8437 13.0069C18.8336 12.1347 18.1632 11.4157 17.3161 11.3295C17.26 11.3236 17.2022 11.3211 17.1445 11.3211C17.0867 11.3211 17.029 11.3245 16.9729 11.3295C16.1258 11.4157 15.4553 12.1356 15.4453 13.0069C15.4453 13.0086 15.4445 13.0094 15.4445 13.0111C15.4445 13.0161 15.4436 13.0212 15.4436 13.0262C15.4436 13.967 16.2062 14.7321 17.1437 14.7321C18.0812 14.7321 18.8437 13.967 18.8437 13.0262C18.8437 13.0203 18.8429 13.0145 18.8429 13.0086C18.8437 13.0078 18.8437 13.0078 18.8437 13.0069V13.0069Z"
            fill="#2A3D48" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.35608 13.0061C7.34855 12.1314 6.67888 11.4098 5.82928 11.3228C5.77237 11.3169 5.71545 11.3144 5.65686 11.3144C5.5991 11.3144 5.54136 11.3177 5.48444 11.3228C4.63484 11.4098 3.96433 12.1313 3.95764 13.0052V13.0077C3.95764 13.0111 3.95679 13.0153 3.95679 13.0186C3.95679 13.9595 4.71936 14.7245 5.65686 14.7245C6.59436 14.7245 7.35687 13.9595 7.35687 13.0186C7.35687 13.0153 7.35608 13.0111 7.35608 13.0077C7.35692 13.0077 7.35608 13.0069 7.35608 13.0061V13.0061Z"
            fill="#2A3D48" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.27948 12.6034C3.28785 12.5566 3.29704 12.5105 3.30792 12.4645C3.31378 12.4385 3.32053 12.4126 3.32806 12.3866C3.34146 12.3381 3.35482 12.2904 3.37073 12.2435C3.37742 12.2234 3.38499 12.2033 3.39252 12.1832C3.41093 12.1322 3.431 12.0819 3.45276 12.0326C3.45778 12.0217 3.46367 12.0108 3.46869 11.9991C3.6135 11.6869 3.82193 11.4115 4.07892 11.188C4.08059 11.1871 4.08139 11.1855 4.08307 11.1838C4.12911 11.1436 4.17681 11.1068 4.2262 11.0699C4.23624 11.0624 4.24632 11.054 4.2572 11.0465C4.30157 11.0147 4.3476 10.9846 4.39447 10.9553C4.41121 10.9452 4.42796 10.9343 4.4447 10.9243C4.48823 10.8992 4.53256 10.8749 4.57776 10.8523C4.60036 10.8406 4.62297 10.8305 4.64557 10.8197C4.68742 10.8004 4.73009 10.7812 4.77362 10.7644C4.80208 10.7535 4.83057 10.7427 4.85986 10.7326C4.90004 10.7184 4.94025 10.7041 4.98126 10.6924C5.01642 10.6824 5.05238 10.6732 5.08838 10.6648C5.12521 10.6556 5.16123 10.6464 5.19806 10.6389C5.24326 10.6296 5.28929 10.6238 5.33533 10.6179C5.36462 10.6137 5.39388 10.6087 5.42401 10.6054C5.50102 10.5978 5.57892 10.5937 5.65845 10.5937C5.73713 10.5937 5.8158 10.5978 5.89282 10.6054C5.92296 10.6079 5.95223 10.6137 5.98236 10.6179C6.0284 10.6238 6.07447 10.6305 6.11884 10.6389C6.1565 10.6464 6.19333 10.6556 6.23016 10.6648C6.26532 10.6732 6.30131 10.6815 6.33563 10.6924C6.37748 10.705 6.41765 10.7184 6.45782 10.7334C6.48628 10.7435 6.51388 10.7535 6.5415 10.7644C6.58587 10.782 6.62857 10.8012 6.67126 10.8205C6.69303 10.8305 6.71481 10.8414 6.73657 10.8523C6.78261 10.8757 6.82777 10.9 6.87213 10.926C6.88804 10.9352 6.9031 10.9452 6.91901 10.9544C6.96672 10.9837 7.01443 11.0147 7.05963 11.0473C7.06884 11.054 7.07726 11.0607 7.08563 11.0666C7.41291 11.3085 7.67656 11.6299 7.849 12.0033C7.85318 12.0116 7.85739 12.02 7.86157 12.0292C7.88417 12.0803 7.90423 12.1322 7.92432 12.1857C7.93101 12.2041 7.93854 12.2226 7.9444 12.241C7.9603 12.2887 7.97458 12.3381 7.98798 12.3866C7.99467 12.4117 8.00134 12.4368 8.0072 12.462C8.01808 12.508 8.02727 12.5549 8.03564 12.6017C8.03816 12.6151 8.04149 12.6285 8.04401 12.6419H12.3666L12.3649 9.61857H0V12.6436H3.2713C3.27381 12.6302 3.27715 12.6169 3.27966 12.6035L3.27948 12.6034Z"
            fill="#2A3D48" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.365 8.90036V0H6.10352e-05V8.90036H12.365Z"
            fill="#2A3D48" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.0805 2.54293V12.6437H14.7596C14.7613 12.6337 14.7638 12.6236 14.7655 12.6136C14.7747 12.5608 14.7856 12.5089 14.7973 12.4579C14.8023 12.4386 14.8065 12.4202 14.8115 12.401C14.8266 12.3457 14.8425 12.2913 14.8609 12.2377C14.8651 12.226 14.8693 12.2143 14.8735 12.2026C14.8952 12.1432 14.9178 12.0837 14.9446 12.0268C15.1471 11.579 15.482 11.2057 15.898 10.9529C15.9055 10.9479 15.9139 10.9428 15.9214 10.9386C15.9717 10.9093 16.0227 10.8809 16.0754 10.8549C16.0905 10.8474 16.1065 10.8399 16.1215 10.8323C16.1692 10.8097 16.2169 10.7888 16.2663 10.7696C16.2889 10.7604 16.3123 10.752 16.3358 10.7436C16.3801 10.7277 16.4245 10.7126 16.4697 10.6992C16.5007 10.69 16.5333 10.6825 16.5651 10.675C16.6045 10.6649 16.6438 10.6549 16.6848 10.6474C16.7275 10.639 16.7719 10.6331 16.8154 10.6273C16.8472 10.6231 16.8774 10.6172 16.9092 10.6139C16.9862 10.6063 17.064 10.6021 17.1427 10.6021C17.2214 10.6021 17.2992 10.6063 17.3762 10.6139C17.408 10.6172 17.439 10.6222 17.47 10.6273C17.5135 10.6331 17.5578 10.639 17.6005 10.6474C17.6407 10.6549 17.6801 10.6658 17.7194 10.675C17.7512 10.6833 17.7839 10.6909 17.8157 10.7001C17.8609 10.7135 17.9044 10.7285 17.9488 10.7445C17.9722 10.7528 17.9965 10.7612 18.0199 10.7704C18.0684 10.7897 18.1161 10.8106 18.163 10.8323C18.1789 10.8399 18.1949 10.8474 18.2108 10.8558C18.2627 10.8817 18.3137 10.9093 18.3631 10.9386C18.3715 10.9437 18.3799 10.9487 18.3882 10.9537C18.8026 11.2057 19.1357 11.5782 19.3383 12.0235C19.3391 12.0251 19.34 12.0268 19.3408 12.0293C19.3659 12.0854 19.3885 12.1423 19.4094 12.2009C19.4144 12.2143 19.4195 12.2277 19.4236 12.2411C19.4412 12.293 19.4571 12.3457 19.4714 12.3993C19.4772 12.4202 19.4823 12.4412 19.4873 12.4621C19.499 12.5115 19.5099 12.5617 19.5182 12.6119C19.5199 12.6228 19.5233 12.6337 19.525 12.6454L20.7587 12.6437V6.97844L16.5952 2.5438L13.0805 2.54293ZM18.4183 7.28486C18.4183 7.48324 18.2584 7.64396 18.0601 7.64396H15.0543C14.8568 7.64396 14.696 7.48324 14.696 7.28486V4.515C14.696 4.31662 14.8559 4.1559 15.0543 4.1559C15.2519 4.1559 15.4125 4.31661 15.4125 4.515V6.92571H18.0609C18.2585 6.92571 18.4183 7.08643 18.4183 7.28481V7.28486Z"
            fill="#2A3D48" />
        </svg>
        <span>
          Cek yang paling dekat di
          <a href="./PetaSetempat" class="font-bold">PetaSetempat</a>
        </span>
      </div>
      <div>
        <a href="./PetaSetempat" class="mx-1"> PetaSetempat </a>
        <a href="./blog" class="mx-1"> Blog </a>
        <a href="./Bantuan" class="mx-1"> Bantuan</a>
      </div>
    </div>
  </div>
  <div class="px-3 py-2 mx-auto lg:px-6 md:px-6 lg:py-2 md:py-2">
    <div
      class="justify-between max-w-screen-xl mx-auto md:flex md:items-center md:justify-between">
      <div class="flex items-center justify-between lg:mt-0 md:mt-0">
        <div
          class="flex justify-between w-full text-sm font-normal text-gray-700 lg:text-xl md:text-md">
          {#if backbtn == 'false'} 
        <div class="block w-full lg:hidden md:hidden">
      <Location/>
      </div>
      <a
      href="/"
      class="block hover:text-gray-700
      lg:text-left md:text-left text-{align} w-full lg:flex md:block hidden "> 
              <h1 class="items-center text-3xl">
                <img src="./assets/logo/logo.svg" class="h-8" alt="Dekatan" width="140" height="32"/>
                {@html title}
              </h1> 
      </a>
          {:else}
            <a
              href="/"
              class="h-8 md:w-32 lg:block md:block hidden hover:text-gray-700
              lg:text-left md:text-left text-{align} lg:mr-3">
              <img src="./assets/logo/logo.svg" class="h-8" alt="Dekatan" width="140" height="32"/>
            </a>
            <button title="{title}"
              on:click={() => window.history.go(-1)}
              class="flex items-center px-3 mx-1 text-sm font-normal text-left border border-gray-200 rounded-lg hover:bg-gray-200 lg:text-md md:text-md lg:px-3 md:px-1 focus:outline-none">
              <svg
                class="inline h-4 my-1 lg:my-1"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg">
                <polygon
                  points="3.828 9 9.899 2.929 8.485 1.515 0 10 .707 10.707 8.485
                  18.485 9.899 17.071 3.828 11 20 11 20 9 3.828 9" />
              </svg>
              <span
                class="flex items-center w-full h-6 p-1 ml-2 overflow-hidden text-xs lg:hidden ellipsis-1 lg:w-32 md:w-32">{title}</span>
            </button>
            {#if filter}
              {#if filtercustom}
                <button
                  class="flex items-center px-2 mx-2 text-xs border border-gray-300 rounded-lg focus:outline-none hover:bg-green-100 hover:text-green-600"
                  on:click={toggleFilter}>{@html filtercustom}</button>
              {:else}
                <button
                  class="flex items-center px-2 mx-2 text-xs border border-gray-300 rounded-lg focus:outline-none hover:bg-green-100 hover:text-green-600"
                  on:click={toggleFilter}>
                  <span>Filter</span>
                  <img src="./assets/svg/search.svg" alt="search" class="inline-block w-3 h-3 m-1 lg:hidden" width="17" height="17"/>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    class="hidden w-2 h-2 m-1 lg:w-3 lg:h-3 lg:inline-block"><path
                      d="M12 12l8-8V0H0v4l8 8v8l4-4v-4z" /></svg>
                </button>
              {/if}
            {/if}
          {/if}
        </div>
      </div>

      <!-- Mobile Menu open: "block", Menu closed: "hidden" -->
      <div
        class="{navToggleMobileval} md:flex md:items-center md:justify-between
        lg:h-auto md:h-auto h-screen flex-1 gap-2">
        <div class="flex flex-col h-full pt-10 mx-2 font-normal md:flex-row md:items-center lg:mx-4 md:mx-0 lg:pt-0 md:pt-0">
          <div class="relative hidden border-l-2 rounded-md lg:border-none lg:block md:hidden">
            
            <span on:click={()=>showhideEl('subbelanja')} on:mouseover={()=>showhideEl('subbelanja')}
            on:click={() => (document.body.style.overflowY = 'auto')} 
            class="block px-2 py-1 mx-2 text-lg text-gray-700 rounded-md cursor-pointer lg:text-sm md:text-sm lg:hover:bg-green-100 hover:text-green-600">
            Belanja
            </span>

            <div id="subbelanja" on:mouseleave={()=>showhideEl('subbelanja')}  on:click={()=>showhideEl('subbelanja')} class="relative top-0 left-0 w-full p-2 py-4 mt-2 bg-white rounded-md rounded-tl-none shadow lg:w-64 rounded-t-md lg:rounded-tl-md lg:absolute lg:mt-12" style="display: none;">
              <span class="absolute top-0 right-0 flex items-center justify-center w-6 h-6 p-1 ml-0 -mt-4 text-center text-green-600 bg-white rounded-full shadow lg:left-0 lg:ml-4 focus:text-black" ><span class="inline-block text-red-600 lg:hidden">X</span> <span class="hidden lg:inline-block">+</span></span>

              {#each listcategory as lc}
                {#if lc.value == 0}  
                  <a href="/belanja" class="block px-2 py-1 mx-2 mt-2 text-gray-700 rounded-md md:mt-0 lg:text-sm md:text-sm text-md hover:bg-green-100 hover:text-green-600">Semua Kategori</a> 
                {:else}   
                  {#if lc.parent}
                    <a 
                      class="block px-2 py-1 mx-2 mt-2 text-gray-700 rounded-md md:mt-0 lg:text-sm md:text-sm text-md hover:bg-green-100 hover:text-green-600"
                      href="belanja/c/{lc.parent.alias}">
                      {lc.parent.title}
                      <span class="hidden">{lc.parent.title}</span>
                    </a> 
                  {/if}
                {/if}
              {/each}
            
            </div>
          </div>
        
          <a
            on:click={() => (document.body.style.overflowY = 'auto')}
            href="/belanja"
            class="relative block px-2 py-1 mx-2 mt-2 text-lg text-gray-700 rounded-md md:mt-0 lg:text-sm md:text-sm hover:bg-green-100 hover:text-green-600 lg:hidden md:block">
            Belanja
          </a>
          <a
            on:click={() => (document.body.style.overflowY = 'auto')}
            href="/tokoku/transaksi"
            class="relative px-2 py-1 mx-2 mt-2 text-lg text-gray-700 rounded-md md:mt-0 lg:text-sm md:text-sm hover:bg-green-100 hover:text-green-600">
            Jualan

            {#if notify}
              {#if notify.jualan > 0}
                <span
                  class="absolute top-0 inline px-2 -ml-2 font-mono text-xs font-normal text-center text-white bg-red-500 bg-opacity-75 rounded-full">
                  {notify.jualan}
                </span>
              {/if}
            {/if}
          </a>

          {#if notify}
            {#if notify.ship_job > 0}
              <a
                on:click={() => (document.body.style.overflowY = 'auto')}
                href="/ngirim/accept"
                class="relative px-2 py-1 mx-2 mt-2 text-lg text-gray-700 rounded-md md:mt-0 lg:text-sm md:text-sm hover:bg-green-100 hover:text-green-600">
                Ngirim

                {#if notify}
                  {#if notify.ship_accepted_wait > 0}
                    <span
                      class="absolute top-0 inline px-2 -ml-2 font-mono text-xs font-normal text-center text-white bg-red-500 bg-opacity-75 rounded-full">
                      {notify.ship_accepted_wait}
                    </span>
                  {:else}
                    <span
                      class="absolute top-0 inline px-2 -ml-2 font-mono text-xs font-normal text-center text-white bg-blue-500 bg-opacity-75 rounded-full">
                      yuk
                    </span>
                  {/if}
                {/if}
              </a>
            {:else}
              <a
                on:click={() => (document.body.style.overflowY = 'auto')}
                href="/ngirim/all"
                class="relative px-2 py-1 mx-2 mt-2 text-lg text-gray-700 rounded-md md:mt-0 lg:text-sm md:text-sm hover:bg-green-100 hover:text-green-600">
                Ngirim

                {#if notify}
                  {#if notify.ship_accepted_wait > 0}
                    <span
                      class="absolute top-0 inline px-2 -ml-2 font-mono text-xs font-normal text-center text-white bg-red-500 bg-opacity-75 rounded-full">
                      {notify.ship_accepted_wait}
                    </span>
                  {/if}
                {/if}
              </a>
            {/if}
          {:else}
            <a
              on:click={() => (document.body.style.overflowY = 'auto')}
              href="/ngirim/accept"
              class="relative px-2 py-1 mx-2 mt-2 text-lg text-gray-700 rounded-md md:mt-0 lg:text-sm md:text-sm hover:bg-green-100 hover:text-green-600">
              Ngirim
            </a>
          {/if}

          <a
            on:click={() => (document.body.style.overflowY = 'auto')}
            href="/PetaSetempat"
            class="block px-2 py-1 mx-2 mt-2 text-lg text-gray-700 rounded-md md:mt-0 lg:text-sm md:text-sm hover:bg-green-100 hover:text-green-600 lg:hidden md:hidden">
            PetaSetempat
          </a>
          <a
            on:click={() => (document.body.style.overflowY = 'auto')}
            href="/belanja/p/keranjang"
            class="relative block px-2 py-2 mx-2 mt-2 text-lg text-gray-700 rounded-md md:mt-0 lg:text-sm md:text-sm hover:bg-green-100 hover:text-green-600 lg:hidden md:hidden">
            Keranjang Belanja

            {#if notify}
              {#if notify.cart > 0}
                <span
                  class="absolute top-0 inline px-2 -ml-2 font-mono text-xs font-normal text-center text-white bg-green-500 bg-opacity-75 rounded-full">
                  {notify.cart}
                </span>
              {/if}
            {/if}
          </a>
          <a
            on:click={() => (document.body.style.overflowY = 'auto')}
            href="/akun"
            class="relative block px-2 py-2 mx-2 mt-2 text-lg text-gray-700 rounded-md md:mt-0 lg:text-sm md:text-sm hover:bg-green-100 hover:text-green-600 lg:hidden md:hidden">
            Akun
          </a>
        </div>
        
        <form
          action="/shop/search"
          class="relative items-stretch justify-center hidden w-full mb-0 mr-4 rounded pointer-events-none md:p-0 search lg:order-none lg:flex md:hidden"
          on:submit|preventDefault={handleSearch}>
           
            <input id="searchfieldsub-{uid}" 
            class="w-full p-3 py-2 pr-12 text-xs font-light bg-white border border-gray-200 rounded shadow outline-none pointer-events-auto md:focus:border-blue-600"
            type="text"
            name="q"
            autocomplete="off"
            bind:value={q}
            placeholder="ketik nama produk & enter" />
            {#if q.length>0}
            <label for="searchfieldsub-{uid}" on:click={()=>q=""}
              class="absolute top-0 bottom-0 right-0 flex items-center justify-center flex-grow h-full pr-4 my-auto mr-10 pointer-events-auto clear">
              <img src="./assets/svg/close.svg" alt="clear" width="18" height="18"/>
            </label> 
            {:else}
            <label for="searchfieldsub-{uid}" on:click={()=>q=""}
              class="absolute top-0 bottom-0 right-0 flex items-center justify-center flex-grow h-full pr-4 my-auto mr-10 pointer-events-auto clear">
              <img src="./assets/svg/close.svg" class="invisible" alt="clear" width="18" height="18"/>
            </label> 
            {/if} 

          <button
            type="submit"
            class="absolute top-0 bottom-0 right-0 flex items-center justify-center flex-grow h-auto px-3 border-l border-gray-400 pointer-events-auto md:border-l-0">
            <img src="./assets/svg/search.svg" alt="search" width="17" height="17"/>
          </button>
        </form>
        
      <Location/>
        <div class="items-center hidden mt-4 lg:flex md:flex md:mt-0">
          {#if message == 'Selamat Datang'}
            <div
              class="flex flex-col h-full md:flex-row md:items-centerfont-normal"> 
              <a
                href="/daftar"
                class="px-2 py-1 mx-2 mt-2 text-lg text-gray-700 rounded-md md:mt-0 lg:text-sm md:text-sm hover:bg-green-100 hover:text-green-600">
                Bergabung
              </a>
              <a
                href="/login"
                class="px-2 py-1 mx-2 mt-2 text-lg text-gray-700 rounded-md md:mt-0 lg:text-sm md:text-sm hover:bg-green-100 hover:text-green-600">
                Masuk
              </a> 
            </div>
          {:else}
            <div
              class="items-center hidden mt-4 lg:flex md:flex md:mt-0">
              <a
                href="/belanja/p/keranjang"
                class="relative hidden px-2 py-1 mx-1 mt-2 text-lg text-gray-300 rounded-md md:block md:mt-0 lg:text-sm md:text-sm hover:bg-green-100 hover:text-green-600 ">
                <svg
                  class="w-5 h-5 m-auto"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20">
                  <path
                    d="M4 2h16l-3 9H4a1 1 0 1 0 0 2h13v2H4a3 3 0 0 1 0-6h.33L3 5
                    2 2H0V0h3a1 1 0 0 1 1 1v1zm1 18a2 2 0 1 1 0-4 2 2 0 0 1 0
                    4zm10 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
                    fill="#555555" />
                </svg>

                {#if notify}
                  {#if notify.cart > 0}
                    <span
                      class="absolute top-0 right-0 inline px-2 -mr-2 font-mono text-xs font-light text-center text-white bg-green-500 bg-opacity-75 rounded-full">{notify.cart}</span>
                  {/if}
                {/if}
              </a> 
              <a
                href="/akun"
                class="relative flex items-center px-2 mx-1 mt-2 text-lg text-gray-300 rounded-md md:mt-0 lg:text-sm md:text-sm hover:bg-green-100 hover:text-green-600 ">
                <div class="w-8 h-8 py-1 text-gray-300 focus:outline-none">
                  <svg
                    class="w-5 h-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20">
                    <path
                      d="M5 5a5 5 0 0 1 10 0v2A5 5 0 0 1 5 7V5zM0 16.68A19.9
                      19.9 0 0 1 10 14c3.64 0 7.06.97 10 2.68V20H0v-3.32z"
                      fill="#555555" />
                  </svg>
                </div>
                <h2
                  class="hidden w-16 h-5 text-sm leading-6 text-gray-600 truncate whitespace-pre-wrap font-base hover:text-blue-600 lg:inline-block">
                  {@html message}
                </h2>
              </a>
            </div>
          {/if}
        </div>
      </div>
    </div>
  </div>
</div>
